import React, {Fragment} from 'react';
import ViewForm, {EmptyMsg} from './ViewForm';
import {GridColumn} from '@atlaskit/page';
import {TextAreaField} from '../../../components/FormFields';
import Button, { ButtonGroup } from '@atlaskit/button';
import {FormFooter} from '@atlaskit/form';
import { EditViewContext } from './EditViewContext';
import i18n from 'i18next';
import {Trans} from 'react-i18next';

const NoteEditForm = ({
  note,
  onChange,
  onCancel,
  fetching,
}) => (
  <Fragment>
    <GridColumn medium={12}>
      <TextAreaField
        name='note'
        required={false}
        onChange={onChange}
        placeholder={i18n.t('clients:Enter note')}
        isDisabled={fetching}
        value={note}
      />
    </GridColumn>
    <GridColumn medium={12}>
      <FormFooter>
        <ButtonGroup>
          <Button appearance='subtle' isDisabled={fetching} onClick={onCancel}>
            <Trans>
              Cancel
            </Trans>
          </Button>
          <Button type='submit' isDisabled={fetching} isLoading={fetching} appearance='danger'>
            <Trans>
              Save
            </Trans>
          </Button>
        </ButtonGroup>
      </FormFooter>
    </GridColumn>
  </Fragment>
)

export default props => {
  const formName = 'note';
  return (
    <EditViewContext.Consumer>
      {({edit, permissions, onChangeEditMode, onChange}) => permissions.note && (
        <ViewForm
          formName={formName}
          title={i18n.t('clients:Note')}
          actionName={permissions.note.edit && i18n.t('Edit')}
          action={onChangeEditMode(formName)}
          editMode={edit === formName}
        >
          {edit === formName
            ? <NoteEditForm {...props} onChange={onChange} />
            : <EmptyMsg msg={props.note ? props.note : i18n.t('clients:No comments')} />
          }
        </ViewForm>
      )}
    </EditViewContext.Consumer>
  )
}